import PropTypes from 'prop-types';

const NetworkType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  deleted: PropTypes.bool, // should this be required?
  name: PropTypes.string.isRequired,
  street: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  zip: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  country: PropTypes.string.isRequired,
  responsiblePersonFirstName: PropTypes.string.isRequired,
  responsiblePersonLastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  guaranteeType: PropTypes.string.isRequired,
  createdAt: PropTypes.string,
  lastUpdatedAt: PropTypes.string,
  rolloutDate: PropTypes.string.isRequired,
});

export default NetworkType;
